// material-ui
import { useColorScheme } from '@mui/material/styles';

// project imports
import { ThemeMode } from 'config';

// assets
import logo from 'assets/images/logo.svg';
import logoDark from 'assets/images/logo-dark.svg';

// ==============================|| LOGO ||============================== //

/** The full ntab logo; the wordmark turns white in dark mode, the mark keeps its colours. */
export default function Logo({ height = 36 }: { height?: number }) {
  const { colorScheme } = useColorScheme();

  // Both dimensions set, at whole pixels, so the browser draws the vector at its displayed size rather than scaling a raster.
  const width = Math.round((height * 1924) / 443);

  return <img src={colorScheme === ThemeMode.DARK ? logoDark : logo} alt="ntab" width={width} height={height} style={{ display: 'block' }} />;
}
